export const BOOKING_URL = 'https://zeeg.me/hireka/erstgesprach-mit-hireka';
export const CTA_LABEL = 'Kostenloses Erstgespräch buchen';
